<template>
  <div class="login">
    <div class="splash">
      <img class="logo" src="../assets/jubilee.png" alt="">
    </div>
    <h1 class="header">Welcome Back</h1>
    <div class="illustration">
      <img src="../assets/joyride.svg" alt="">
    </div>
    <div class="form">
      <input v-model="email" placeholder="Email" />
      <br />
      <input type="password" v-model="password" placeholder="Password" />
      <br />
      <button @click="login">Sign In</button>
      <p>
        Don't have an account ?
        <br />You can
        <router-link to="/signup">sign up here</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "login",
  props: ["api"],
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    login: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          user => {
            this.$router.replace("home");
          },
          err => {
            alert("Oops. " + err.message);
          }
        );
    }
  }
};
</script>

<style scoped lang="scss">
/* "scoped" attribute limit the CSS to this component only */

.login {
  /* margin-top: 40px; */
  .illustration{
    text-align: center;
    padding: 2rem 0 3rem 0;
    img{
    
      width: 20rem;
    }
  }

  .splash{
    display: block;
    background-color: var(--green);
    height: 100vh;
    width: 100vw;
    z-index: 99;
    position: absolute;
    top: 0;
    animation: splash 3s ease-in-out 0s 1 forwards;

    .logo{
      width: 24rem;
      position: absolute;
      top: 33%;
      z-index: 99;
    }
  }

  @-webkit-keyframes splash {
    0%{
      clip-path: circle(100% at 50% 50%);
      opacity: 1
    }
    90%{
      opacity: .95;
    }
    100%{
      clip-path: circle(0% at 50% 50%);
      opacity: 0;
      display: none;
    }
  }

  .header {
    font-family: var(--sans);
    padding: 0 2rem;
  }

  .form {
    text-align: center;
  }
}
input {
  margin: 10px 0;
  width: 60%;
  padding: 15px;
  -webkit-appearance: none;
  box-shadow: none;
  outline: none;
  border: 1px solid #bbb;
}
button {
  margin-top: 20px;
  /* width: 10%; */
  cursor: pointer;
}
p {
  margin-top: 40px;
  font-size: 1rem;
  font-family: var(--serif);
}
p a {
  text-decoration: underline;
  cursor: pointer;
}
</style>